import type { ReactNode } from 'react';
import { VStack } from '@cbhq/cds-web/layout';

import type { LEProductAccessGroupParams } from './LEProductAccessGroup';
import { LEProductAccessGroup } from './LEProductAccessGroup';

export type MultiLEProductAccessGroupProps = {
  entities: LEProductAccessGroupParams[];
  footer?: ReactNode;
  defaultExpanded?: boolean;
};

export function MultiLEProductAccessGroup({
  entities,
  footer,
  defaultExpanded,
}: MultiLEProductAccessGroupProps) {
  return (
    <VStack gap={2} width="100%">
      {entities.map((entity) => (
        <LEProductAccessGroup
          key={entity.entityRow.entityId}
          {...entity}
          defaultExpanded={defaultExpanded ?? entity.defaultExpanded}
        />
      ))}
      {footer}
    </VStack>
  );
}
